import { Table } from '@morressier/alembic';
import { memo } from 'react';
import MemberRow from './MemberRow';
import ListLoader from 'src/components/ListLoader';
import SubmissionLoader from 'src/pages/Organization/Workspace/Submissions/SubmissionLoader';

type Props = {
  members: any[];
  roles: string[];
  submissionContextId: string;
  isLoading: boolean;
  isCheckboxHidden?: boolean;
};

export default memo(function MembersTable({
  members,
  roles,
  submissionContextId,
  isLoading,
  isCheckboxHidden=false
}: Props) {
  return (
    <Table>
      <Table.HeaderRow gap={2}>
        <Table.HeaderCell width="40px" />
        <Table.HeaderCell flex="1">Name</Table.HeaderCell>
        <Table.HeaderCell flex="1">Email</Table.HeaderCell>
        <Table.HeaderCell width="180px">Role</Table.HeaderCell>
      </Table.HeaderRow>
      <Table.Body>
        {isLoading ? (
          <ListLoader />
        ) : members.length === 0 ? (
          <SubmissionLoader
            title="No Members Found"
            subTitle="We could not find any members matching the provided name or email."
            bgColor="neutralSecondaryFill"
          />
        ) : (
          members.map(member => (
            <MemberRow
              key={member.id}
              member={member}
              roles={roles}
              submissionContextId={submissionContextId}
              isCheckboxHidden={isCheckboxHidden}
            />
          ))
        )}
      </Table.Body>
    </Table>
  );
});
